import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MenuService } from '../../../services/menu/menu.service';
import { MenuItem, MenuPanelItem } from '../../../domain/menu.domain';
import { IconComponent } from '../../../components/icon/icon.component';

@Component({
  selector: 'td-wb-menu-page',
  templateUrl: './menu-page.component.html',
  styleUrls: ['./menu-page.component.scss'],
  imports: [
    IconComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuPageComponent implements OnInit {
  flattenLocalNavigation: Array<MenuItem> = [];

  constructor(private menuService: MenuService) {
  }

  ngOnInit(): void {
    const menu = this.menuService.getMenu();
    menu.localNavigation.forEach((menuItem: MenuPanelItem): void => {
      if (menuItem.menu !== undefined) {
        this.flattenLocalNavigation = this.flattenLocalNavigation.concat(menuItem.menu[0].item);
      }
    });
  }
}
